import {RootState} from './interfaces'

export const agreementSelector = (state: RootState) => state.agreement
